export const organizationDetailsKeys = {
  all: ['organization-details'],
  lists: () => [...organizationDetailsKeys.all, 'list'],
  list: () => [...organizationDetailsKeys.lists()],
} as const;
